import React from 'react';
import styled from 'styled-components';
import { COLOR, FONT_SIZE, SPACING } from '../../../constants/theme';

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md};
  padding: 9px 0;

  & + & {
    border-top: 1px solid ${COLOR.border};
  }

  .anticon {
    flex: none;
    margin-top: 3px;
    color: ${COLOR.textSecondary};
  }
`;

const Content = styled.p`
  margin: 0;
  font-size: ${FONT_SIZE.body};
  line-height: 1.55;
  color: ${COLOR.text};
`;

const KeyTerm = ({ icon, children }) => (
  <Row>
    {icon}
    <Content>{children}</Content>
  </Row>
);

export default KeyTerm;
